import PropTypes from 'prop-types';
import React, { memo, useEffect, useState} from 'react';
import { useSpring, animated, config } from '@react-spring/web'
import { $t } from '../../i18n';
import { createParagraph } from '../../utils';
import './CompanyInfo.scss';

const companies = {
	wave: {
		name: 'company_wave_name',
		description: 'company_wave_desc',
	},
	track: {
		name: 'company_track_name',
		description: 'company_track_desc',
	},
	propine: {
		name: 'company_propine_name',
		description: 'company_propine_desc',
	},
	techemy: {
		name: 'company_techemy_name',
		description: 'company_techemy_desc',
	},
	strix: {
		name: 'company_strix_name',
		description: 'company_strix_desc',
	},
}

export const CompanyInfo = memo(props => {
	const { className, isMobile, companyId, onClose } = props;
	const [isModalExpanded, setIsModalExpanded] = useState(false);
	const [companyName, setCompanyName] = useState('');
	const [companyDescription, setCompanyDescription] = useState('');
	const [isComponentVisible, setIsComponentVisible] = useState(false);
	const isContentAvailable = !!companies[companyId];
	const extendedClassName = (isMobile ? 'company-info-mobile' : 'company-info')
		+ (isModalExpanded ? ' company-info-mobile--expanded' : '')
		+ (className ? ' ' + className : '');

	const onRest = () => {
		setIsComponentVisible(isContentAvailable);
	}
	const style = useSpring({
		opacity: (!isMobile && isContentAvailable) ? 1 : 0,
		config: config.molasses,
		onRest
	});
	const handleModalClose = () => {
		setIsModalExpanded(false);
		
		setTimeout(() => {
			onClose();
			setIsComponentVisible(false);
		}, 250);
	}

	useEffect(() => {
		if (isContentAvailable) {
			const companyName = $t(companies[companyId].name);
			const companyDescription = $t(companies[companyId].description);

			setCompanyName(companyName);
			setCompanyDescription(companyDescription);
			setIsComponentVisible(isContentAvailable);
			setTimeout(() => {
				setIsModalExpanded(true);
			}, 150)
		}
	}, [isContentAvailable, companyId]);

	return (<>
		{isComponentVisible && !isMobile && <animated.div className={extendedClassName} style={style} onClick={onClose}>
			<h2>{companyName}</h2>
			{createParagraph(companyDescription)}
		</animated.div>}
		{isComponentVisible && isMobile && <div className={extendedClassName} style={style}>
			<div className="company-info-mobile-modal">
				<div className="company-info-mobile-bg-container">
					<img src={require('../../assets/images/modal/frame-black-side.png')} className="company-info-mobile-bg-start" />
					<img src={require('../../assets/images/modal/frame-black-middle.png')} className="company-info-mobile-bg-middle" />
					<img src={require('../../assets/images/modal/frame-black-side.png')} className="company-info-mobile-bg-end" />
				</div>
				<div className="company-info-mobile-content">
					<h2>{companyName}</h2>
					{createParagraph(companyDescription)}
				</div>
				<img src={require('../../assets/images/modal/icon-close.png')} className="icon-close" onClick={handleModalClose} />
			</div>
		</div>}
	</>);
});

CompanyInfo.propsTypes = {
	className: PropTypes.string,
	isMobile: PropTypes.bool,
	companyId: PropTypes.string,
	onClose: PropTypes.func
};
